@if (!column.isHidden) {
  <div class="u-flex u-alignCenter">
    <p class="t-data t-bold" [innerHTML]="_cellValue"></p>
  </div>
}
